import withAuthorization from "./withAuthorization";

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/components/Session/index.ts